import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
// @mui
import { useTheme, styled } from '@mui/material/styles';
import { Box, Card, CardHeader, CircularProgress } from '@mui/material';
// utils
import { fNumber } from '../../../utils/formatNumber';
// components
import { useChart } from '../../../components/chart';

// ----------------------------------------------------------------------

const CHART_HEIGHT = 395;

const StyledSpinnerWrapper = styled('div')(({  theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: CHART_HEIGHT,
  marginTop: theme.spacing(2)
}));

// ----------------------------------------------------------------------

AppConversionRates.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  chartData: PropTypes.array.isRequired,
};

export default function AppConversionRates({ title, subheader, chartData, loading, ...other }) {
  const chartLabels = chartData.map((i) => i.label);

  const chartSeries = chartData.map((i) => i.value);

  const chartOptions = useChart({
    tooltip: {
      marker: { show: false },
      y: {
        formatter: (seriesName) => fNumber(seriesName),
        title: {
          formatter: () => '',
        },
      },
    },
    plotOptions: {
      bar: { horizontal: true, barHeight: '28%', borderRadius: 2 },
    },
    xaxis: {
      categories: chartLabels,
    },
  });

  return (
    <Card {...other}>
      <CardHeader title={title} subheader={subheader} />

      <Box sx={{ mx: 3 }} dir="ltr">
        {loading ?
            <StyledSpinnerWrapper>
              <CircularProgress />
            </StyledSpinnerWrapper>
          :
            <ReactApexChart type="bar" series={[{ data: chartSeries }]} options={chartOptions}
              // height={364}
              height={CHART_HEIGHT}
            />   
        }
      </Box>
    </Card>
  );
}
